












































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import * as routeNames from '../../order-management/router-names';

import listPageMixin from '@root/common/mixins/list-page/list-page.vue';
// import AddEditModal from './components/add-edit-modal.vue'
import toTree, { ITreeNode } from '@root/utils/to-tree';

import tableColumnData from './tableColumnData';
import * as _ from 'lodash';
import ParkingReviewImage from '../../../components/parking-review-image/index.vue';
import inputNumberWithAddon from '../../../components/input-number-with-addon/index.vue';
import { DictUserStatus, DictUserStatusMap } from '@/types/system-management/dictionaries';
import { queryOrderCleanList, clenMultiOrder, enterOrExit } from '@/api/exception-management/index';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
import PlateInput from '../../../components/plate-input/index.vue';

@Component({
  name: 'CleanCar',
  components: { ParkingReviewImage, ParkingLotSearch, PlateInput, inputNumberWithAddon }
})
export default class CleanCar extends Mixins(listPageMixin) {
  // 查询条件
  userName = ''; // 账号
  realName = ''; // 真实姓名
  orgDepId: string[] | string | null = null; // 机构Id
  positionId: string = ''; // 岗位id
  searchValue = ''; // 查询条件内容值
  searchType = 'userName'; // 查询条件下拉框当前值
  positionOptions: IOption[] = []; // 岗位下拉选项
  minNumber = 1;
  // 查看图片弹框
  showReviewImgModel: boolean = false;
  viewImageDialogFieldsDefination = '车牌-plate 入场时间-enterTime 入场位置-enterChannelName';
  initialTableColumnData = tableColumnData;
  // 弹窗控制
  // addEditModalVisible: boolean = false
  isEdit: boolean = false;
  // addEditModalData: any = []
  viewImageModelData: {} = {}; //查看图片所使用的视图数据
  tableData: any[] = []; // 表数据
  tableLoading: boolean = false;
  dictUserStatus = DictUserStatus; //用户状态字典
  dictUserStatusMap = DictUserStatusMap; //用户状态字典map
  currentUser: any = {};
  current = 1;
  selectedRows = [];

  private validateBeforeSearch = () => {
    if (
      'plateTail' in this.filterParam &&
      (this.filterParam.plateTail || '').trim() !== '' &&
      (this.filterParam.plateHead || '').trim() === ''
    ) {
      this.$message.warning('请选择车牌头');
      return false;
    }
  };

  private requestHandler = {
    list: queryOrderCleanList,
    clean: clenMultiOrder
  };
  dataTransferCenter = {
    onSearch: (o: any) => {
      return {
        parkIds: o.parkIds instanceof Array ? o.parkIds.join(',') : o.parkIds,
        currPage: this.current,
        // plate:o.adapterDataForViewModel.plateHead+o.adapterDataForViewModel.plateTail,
        // userId:'',
        pageSize: this.pageSize
      };
    }
  };

  private testArr = [];

  private filterParam: any = {
    adapterDataForViewModel: {
      enterTimeArrHandler: {
        model: [],
        // 入场时间改变
        onChange: (date: any, dateString: any) => {
          this.testArr.push(this);
          // @ts-ignore
          window.testArr = this.testArr;
          let [startTime, endTime] = dateString;
          this.filterParam.startTime = startTime;
          this.filterParam.endTime = endTime;
        }
      },

      plateModel: false
    },
    stopDay: '7', //停车：几天以上
    parkIds: [], // 车场ID集合,多车场逗号分隔
    plateHead: '', // 车牌头
    plateTail: '',
    startTime: '', // 开始时间
    endTime: '', // 结束时间
    // authTypes: [], // 车辆类型,多个类型逗号分隔（00：临停小车 01：临停大车 02：产权车 03：月卡车）
    // carTypes: [], // 车型,多个类型逗号分隔,00：小车，01：大车
    enterTimeOrderBy: '',
    parkingTimeOrderBy: ''
  };

  /**
   * 车牌号组件发生变化
   */
  plateChange([plateHead, plateTail]: any) {
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }

  // 跳转详情
  toDetail(pkOrderId: any, parkId: any) {
    this.$router.push({
      name: routeNames.ENTER_CAR_DETAIL,
      params: {
        pkOrderId,
        parkId
      }
    });
  }

  // 查看图片
  reviewImages(record: {}, text: any) {
    this.viewImageModelData = record;
    this.showReviewImgModel = true;
  }

  onTableFilterClearCallback(filterParam: any) {
    filterParam.adapterDataForViewModel.plateModel = true;
    //this.filterParam.stopDay = ''
    this.filterParam.adapterDataForViewModel.enterTimeArrHandler = {
      model: [],
      // 入场时间改变
      onChange: (date: any, dateString: any) => {
        this.testArr.push(this);
        // @ts-ignore
        window.testArr = this.testArr;
        let [startTime, endTime] = dateString;
        this.filterParam.startTime = startTime;
        this.filterParam.endTime = endTime;
      }
    };
  }

  // 查询条件下拉框选项
  get searchOption() {
    return [
      {
        value: 'userName',
        label: '登录账号'
      },
      {
        value: 'realName',
        label: '真实姓名'
      }
    ];
  }

  // 所属车场树状图列表
  parkTree: ITreeNode<any>[] = [];
  getParkTreeDebounce: any = null;

  /**
   * 生命周期
   */

  // mounted() {
  //   this.fetchTableData()
  // }

  /**
   * method
   */

  async onMultiClearClick(recordCollection: any[] = []) {
    recordCollection = recordCollection || this.selectedRows;
    let isInDifferentParkPlace = recordCollection.find(item => item.parkName != recordCollection[0].parkName);

    if (isInDifferentParkPlace) {
      this.$message.warning('请选择同一车场的记录');
      return false;
    }
    try {
      await this.requestHandler.clean({
        parkId: recordCollection[0].parkId,
        pkOrderIds: recordCollection.map(item => item.pkOrderId).join(',')
      });
      this.selectedRows = [];
      this.fetchTableData();
    } catch (e) {
      this.$message.warning((e && e.msg) || '系统异常请稍后再试');
    }
  }

  /**
   * 新建弹窗展示
   */
  // showAddModal() {
  //   this.isEdit = false
  //   this.addEditModalVisible = true
  // }
  /**
   * 点击搜索按钮
   */
  private search() {
    this.current = 1;
    this.fetchTableData();
  }

  /**
   * 编辑弹窗展示
   */
  // showEditModal(item: any) {
  //   this.isEdit = true
  //   this.addEditModalData = {
  //     ...item,
  //     positionIdList: item.positionList.map((item: any) => item.positionId),
  //   }
  //   this.addEditModalVisible = true
  // }

  /**
   * 弹窗取消
   */
  // handleModalCancel() {
  //   this.addEditModalVisible = false
  // }

  /**
   * 弹窗保存
   */
  handleModalCreate() {
    // this.addEditModalVisible = false
    this.fetchTableData();
  }

  activated() {
    if (this.$route.query.parkDay) {
      this.filterParam.stopDay = this.$route.query.parkDay;
    }
    if (this.$route.query.parkId) {
      this.filterParam.parkIds = this.$route.query.parkId;
    }
  }

  // 表头筛选
  onSortChange({ sortList = [], property, order }) {
    // fetchTableData 查询方法
    sortList.forEach(item => {
      this.filterParam[`${item.property}OrderBy`] = item.order;
    });
    if (!order) {
      this.filterParam[`${property}OrderBy`] = '';
    }
    this.current = 1;
    this.fetchTableData();
  }
}
